module.exports = __webpack_public_path__ + "static/media/monte-de-piedad-white.82233efd.png";